var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc_home"},[_c('Header'),_c('Download'),_c('About'),_c('Customers'),_c('Partners'),_c('Merchants'),_c('NewsRoom'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }